import React from 'react';

export default function VoiceEnrollRecording({ name, mode, recording, timer, segmentCount, onRecord, onStop, onContinue, onReset, saving }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f2f4f8', padding: '24px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ color: '#0d4a33', fontSize: '28px', marginBottom: '8px' }}>Voice Recording</h1>
          <p style={{ color: '#6b7280', fontSize: '16px' }}>
            Hello <strong>{name}</strong>! Record your voice for emotional assessment.
          </p>
        </div>

        <div style={{ background: 'white', borderRadius: '16px', padding: '32px', boxShadow: '0 16px 40px rgba(0,0,0,0.1)', marginBottom: '24px' }}>
          <h3 style={{ color: '#1e3b8b', marginBottom: '24px', textAlign: 'center' }}>Choose Recording Mode</h3>

          <div style={{ display: 'grid', gap: '16px' }}>
            <button
              onClick={() => onRecord('40s')}
              disabled={recording}
              style={{
                padding: '24px 32px',
                fontSize: '18px',
                fontWeight: '600',
                background: recording && mode !== '40s' ? '#e5e7eb' : '#0d4a33',
                color: recording && mode !== '40s' ? '#9ca3af' : 'white',
                border: 'none',
                borderRadius: '12px',
                cursor: recording ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s'
              }}
            >
              🎤 40 Seconds (Continuous)
              <div style={{ fontSize: '14px', fontWeight: '400', marginTop: '8px', opacity: 0.8 }}>
                Record your voice for 40 seconds in one go
              </div>
            </button>

            <button
              onClick={() => onRecord('8s')}
              disabled={recording}
              style={{
                padding: '24px 32px',
                fontSize: '18px',
                fontWeight: '600',
                background: recording && mode !== '8s' ? '#e5e7eb' : '#0d4a33',
                color: recording && mode !== '8s' ? '#9ca3af' : 'white',
                border: 'none',
                borderRadius: '12px',
                cursor: recording ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s'
              }}
            >
              🎤 8 Seconds Quick Check
              <div style={{ fontSize: '14px', fontWeight: '400', marginTop: '8px', opacity: 0.8 }}>
                Record 5 short sections of 8 seconds each
              </div>
            </button>
          </div>
        </div>

        {(recording || segmentCount > 0) && (
          <div style={{ background: 'white', borderRadius: '16px', padding: '32px', boxShadow: '0 16px 40px rgba(0,0,0,0.1)', marginBottom: '24px' }}>
            <h3 style={{ color: '#1e3b8b', marginBottom: '24px', textAlign: 'center' }}>
              {mode === '40s' ? 'Recording in Progress' : `Recording Progress (${segmentCount}/5 segments completed)`}
            </h3>

            {mode === '8s' && (
              <div style={{ marginBottom: '24px' }}>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '16px' }}>
                  {[0, 1, 2, 3, 4].map((i) => (
                    <div
                      key={i}
                      style={{
                        width: '48px',
                        height: '8px',
                        borderRadius: '4px',
                        background: i < segmentCount ? '#10b981' : (i === segmentCount && recording ? '#f59e0b' : '#e5e7eb'),
                        transition: 'all 0.3s ease'
                      }}
                    />
                  ))}
                </div>
                <p style={{ textAlign: 'center', color: '#6b7280', fontSize: '14px' }}>
                  {segmentCount < 5
                    ? (recording ? 'Recording segment...' : `Segment ${segmentCount + 1} of 5 - Click below to continue`)
                    : 'All 5 segments completed!'}
                </p>
              </div>
            )}

            {recording && (
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <div style={{ fontSize: '64px', marginBottom: '16px' }}>🎙️</div>
                <div style={{ fontSize: '36px', fontWeight: '700', color: '#0d4a33', marginBottom: '8px' }}>
                  {timer}s
                </div>
                <div style={{ fontSize: '14px', color: '#dc2626', marginBottom: '16px' }}>
                  Recording in progress...
                </div>
                <button
                  onClick={onStop}
                  style={{
                    padding: '14px 28px',
                    fontSize: '16px',
                    fontWeight: '600',
                    background: '#dc2626',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={e => e.target.style.background = '#b91c1c'}
                  onMouseOut={e => e.target.style.background = '#dc2626'}
                >
                  Stop Recording
                </button>
              </div>
            )}

            {mode === '8s' && !recording && segmentCount < 5 && (
              <div style={{ textAlign: 'center' }}>
                <button
                  onClick={onContinue}
                  style={{
                    padding: '16px 32px',
                    fontSize: '18px',
                    fontWeight: '600',
                    background: '#0d4a33',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    marginBottom: '16px',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={e => e.target.style.background = '#0a3a28'}
                  onMouseOut={e => e.target.style.background = '#0d4a33'}
                >
                  {segmentCount === 0 ? 'Start Recording' : `Record Segment ${segmentCount + 1}/5`}
                </button>
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
              <button
                onClick={onReset}
                disabled={saving}
                style={{
                  padding: '12px 24px',
                  fontSize: '14px',
                  fontWeight: '600',
                  background: '#f3f4f6',
                  color: '#4b5563',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  cursor: saving ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseOver={e => !saving && (e.target.style.background = '#e5e7eb')}
                onMouseOut={e => e.target.style.background = '#f3f4f6'}
              >
                Reset & Start Over
              </button>
            </div>
          </div>
        )}

        {saving && (
          <div style={{ background: 'white', borderRadius: '16px', padding: '32px', textAlign: 'center' }}>
            <div style={{ fontSize: '18px', color: '#0d4a33' }}>Saving recording...</div>
          </div>
        )}
      </div>
    </div>
  );
}
